
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import {default as Link, Controller as LinkController} from './../../zviz2/zviz/components/link';
import TextBox from './../../zviz2/zviz/components/textbox';
import {extend} from './../../zviz2/zviz/functions';
import {styleWords} from './../../styles';
import config from './../../config';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class Controller extends GroupController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);
        this.showMenu = false;
    }

}

class NavigationLink extends LinkController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);
        this.isHover = false;
    }

    isActive(){
        return (this.data.tag == state.get('source'));
    }

    linkClick(event){
        if(this.data.tag == 'ai'){
            // external link, do nothing
            return;
        }
        event.preventDefault();
        if(state.get('renderSize') != 'large'){
            if(this.parent.showMenu == false){
                this.parent.showMenu = true;
                this.parent.update();
                return;
            }
        }
        this.parent.showMenu = false;
        state.set('source', this.data.tag);
        if(this.data.tag=='planned'){
            let current = (new Date()).getFullYear();
            state.set('filter.year', [current]);
        }
        this.parent.update();
    }

}

let NavLinkBlueprint = extend({
    type: NavigationLink,
    properties: {
        style: extend({
                lineHeight: '40px',
                height: '42px',
                color: (ctrl) => ctrl.isActive() ? '#230050' : 'white' ,
                padding: '0px 15px',
                borderRight: (ctrl) => ( ctrl.isActive()? '1px solid #11223e': 
                    (ctrl.isHover? '1px solid #516697': '1px solid #5d81b9')),
                display: (ctrl) => ( (state.get('renderSize') != 'large')? 'block': 'inline-block'),
                margin: (ctrl) => ( (state.get('renderSize') != 'large')? '0px -20px': '0px'),
                borderTop: (ctrl) => ( ctrl.isActive() ? '2px solid #fb3a49' :
                        (state.get('renderSize') != 'large') ?
                            '1px solid #263062':
                            `2px solid ${(ctrl.isHover? '#151F85': '#1e2dbe')}`
                ),
                outline: 'none',
                // fontSize: (ctrl) => ( (state.get('renderSize') == 'large')? '12pt': '10pt' ),
                borderLeft: (ctrl) => ( ctrl.isActive()? '1px solid #263062': '1px solid #37468e'), 
                backgroundColor: (ctrl) => ( (ctrl.isActive()? '#fff':
                    (ctrl.isHover? '#151F85': '#1e2dbe'))),
                fontSize: (ctrl) => (
                    window.innerWidth > 1180 ? '12pt': '10pt'
                )
            }, styleWords)
    },
    events: {
        mouseover: (event, ctrl) => { ctrl.isHover = true; ctrl.hasChanged=true; },
        mouseout: (event, ctrl) => { ctrl.isHover = false; ctrl.hasChanged=true; }
    }
}, Link)


let BlprLinks = [extend({
    properties: {
        data: { tag: 'eval' },
        content: config.data.sourceTitlesLong['eval']
    }
}, NavLinkBlueprint),
extend({
    properties: {
        data: { tag: 'll' },
        content: config.data.sourceTitlesLong['ll']
    }
}, NavLinkBlueprint),
extend({
    properties: {
        data: { tag: 'gp' },
        content: config.data.sourceTitlesLong['gp']
    }
}, NavLinkBlueprint),
extend({
    properties: {
        data: { tag: 'rec' }
    },
    children: [
        // We split Recommendations & management responses into two TextBoxes and scale down the text of the
        // second box in order to make things fit in the navigation bar
        extend({
            properties: {
                content: config.data.sourceTitlesLong['rec'].split(' &')[0],
            }
        }, TextBox),
        extend({
            properties: {
                style: {
                    fontSize: '70%',
                    marginLeft: '5px',
                },
                content: '&' + config.data.sourceTitlesLong['rec'].split(' &')[1],
            }
        }, TextBox),
    ]
}, NavLinkBlueprint),
extend({
    properties: {
        data: { tag: 'planned' },
        content: config.data.sourceTitlesLong['planned']
    }
}, NavLinkBlueprint),

extend({
    properties: {
        data: { tag: 'ai' },
        attributes: {
            href: 'https://ievalassistance.azurewebsites.net/',
            target: "_blank",
            class: 'nav-link-ai'},
        content: config.data.sourceTitlesLong['ai'],
        style: {
            backgroundColor: (ctrl) => (
                ctrl.isActive() ?
                    '#fff':
                    (ctrl.isHover? '#771449': '#960a55')
            )
        }
    }
}, NavLinkBlueprint)];

let MobileBtn = extend({
    properties: {
        data: {
            tag: (ctrl) => ( state.get('source') )
        },
        content: (ctrl) => ( config.data.sourceTitlesLong[ctrl.data.tag]? 
                config.data.sourceTitlesLong[ctrl.data.tag]: 
                config.data.sourceTitlesLong['eval'] ),
        style: extend({
                lineHeight: '40px',
                color: 'white' ,
                padding: '0px 28px 0px 15px',
                borderRight: '7px solid #263062',
                borderTop: 'none',
                margin: '0px',
                display: 'inline-block',
                outline: 'none',
                borderLeft: '1px solid #263062',
                backgroundColor: '#263062', 
                background: '#263062 url(\'' + config.imgPath + 'down-arrow-large.png\') right center no-repeat'
            }, styleWords)
    },
    events: {
        mouseover: (event, ctrl) => { ctrl.isHover = true; ctrl.hasChanged=true; },
        mouseout: (event, ctrl) => { ctrl.isHover = false; ctrl.hasChanged=true; }
    }
}, NavLinkBlueprint);

let Blueprint = extend({
    type: Controller,
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'source') )
    ],
    properties: {
        style: {
            margin: '0px auto',
            maxWidth: '1138px',
            padding: '0px 20px'
        }
    },
    events: {  },
    children: [
        // extend({
        //     properties: {
        //         style: extend({
        //                 lineHeight: '30px',
        //                 color: 'white',
        //                 paddingRight: '15px'
        //             }, styleWords),
        //         content: (ctrl) => ( (state.get('renderSize') == 'large')? 'Select source': 'Source' )
        //     }
        // }, TextBox),

        (ctrl) => ( (state.get('renderSize') != 'large')? MobileBtn: BlprLinks ),

        extend({
            properties: {
                style: extend({
                    background: 'transparent url(\'' + config.imgPath + 'help.png\') left 8px no-repeat',
                    color: 'white',
                    display: 'block',
                    padding: '0px 0px 0px 27px',
                    height: '40px',
                    lineHeight: '40px',
                    cssFloat: 'right',
                    marginRight: (ctrl) => ( (state.get('renderSize') != 'large')? '-10px': '0px') 
                }, styleWords),
                attributes: {
                    href: config.root + 'docs/guide.pdf?v2',
                    target: '_blank'
                },
                content: '' 
            },
            events: {
                // click: (event, ctrl) => { alert('The support page is currently not yet available'); }
            }
        }, Link),

        (ctrl) => ( (ctrl.showMenu && state.get('renderSize') != 'large')? BlprLinks.slice(0): [] )
    ]
}, Group);


export default Blueprint;
export {Controller, Blueprint};
